const PasswordIcon = () => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <title>3E590C38-7351-4D31-B8B3-7D442CAF1B59</title>
    <desc>Created with sketchtool.</desc>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard-Copy"
        transform="translate(-337.000000, -618.000000)"
        fill="#EE4C77"
      >
        <g
          id="Group-4"
          transform="translate(337.000000, 551.000000)"
        >
          <g
            id="ic_cadeado"
            transform="translate(0.000000, 67.000000)"
          >
            <g
              id="Page-1"
              transform="translate(5.120000, 3.200000)"
            >
              <path d="M13.6788045,6.3075 L4.35383547,6.3075 L4.35383547,6.26458 L4.35383547,3.50146 C4.35383547,2.47979 5.18037736,1.65271 6.20138264,1.65271 L9.41886792,1.65271 C10.4398732,1.65271 11.2664151,2.47979 11.2664151,3.50146 L11.2664151,3.67604 C11.2664151,4.08958 11.6138989,4.43729 12.0271698,4.43729 C12.4404408,4.43729 12.7879245,4.08958 12.7879245,3.67604 L12.7879245,3.50146 C12.7879245,1.65271 11.2664151,0.13021 9.41886792,0.13021 L6.20138264,0.13021 C4.35383547,0.13021 2.83232604,1.65271 2.83232604,3.50146 L2.83232604,6.28604 L2.83232604,6.32896 L1.65859019,6.32896 C0.789156226,6.32896 0.0712935849,7.04729 0.0712935849,7.91729 L0.0712935849,16.90033 C0.0712935849,17.77033 0.789156226,18.48866 1.65859019,18.48866 L13.6788045,18.48866 C14.5482385,18.48866 15.2661011,17.77033 15.2661011,16.90033 L15.2661011,7.91729 C15.2661011,7.02583 14.5482385,6.3075 13.6788045,6.3075 L13.6788045,6.3075 Z M13.7445917,16.89917 C13.7445917,16.94238 13.7014098,16.965 13.6788045,16.965 L1.68119547,16.965 C1.63801358,16.965 1.6154083,16.92208 1.6154083,16.89917 L1.6154083,7.91729 C1.6154083,7.87408 1.65859019,7.85146 1.68119547,7.85146 L13.7014098,7.85146 C13.7445917,7.85146 13.767197,7.89467 13.767197,7.91729 L13.767197,16.89917 L13.7445917,16.89917 Z" id="Fill-1" />
              <path d="M9.39742189,13.14625 C9.39742189,14.09542 8.62855245,14.86479 7.68,14.86479 C6.73144755,14.86479 5.96257811,14.09542 5.96257811,13.14625 C5.96257811,12.19708 6.73144755,11.42771 7.68,11.42771 C8.62855245,11.42771 9.39742189,12.19708 9.39742189,13.14625" id="Fill-2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PasswordIcon;
